// src/pages/PollingUnits/PollingUnits.js
"use client"

import React, { useEffect, useMemo, useRef, useState } from "react"
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import "./PollingUnits.css"

// Fix default icon path issue for Leaflet (works in CRA)
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

// --- Full pollingUnits array (as you provided) ---
const pollingUnits = [
  {"ward name": "BADUME WARD", "polling unit name": "BADUME P.S I",           "polling unit code": "001", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "BADUME P.S II",         "polling unit code": "002", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "BAGARE/DUGURAMA",       "polling unit code": "003", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "DANFALKE",             "polling unit code": "004", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "GAURAKI OPEN SPACE",    "polling unit code": "005", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "KAWAJI, SPS I",         "polling unit code": "006", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "KAWAJI, SPS II",        "polling unit code": "007", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "KYAUTA, C/GARI I",       "polling unit code": "008", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "KYAUTA, C/GARI II",      "polling unit code": "009", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SABO KANAWA I",         "polling unit code": "010", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SABO KANAWA II",        "polling unit code": "011", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SABO TSOHUWA HEALTH CENTRE", "polling unit code": "012", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SANAKUR",              "polling unit code": "013", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "TSAURE I",              "polling unit code": "014", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "TSAURE II",             "polling unit code": "015", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YAKASAI I",             "polling unit code": "016", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YAKASAI II",            "polling unit code": "017", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YAKASAI III",           "polling unit code": "018", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YALWAN SADI",          "polling unit code": "019", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YANBUNDU",             "polling unit code": "020", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YANLEMAN",             "polling unit code": "021", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YOLA I",               "polling unit code": "022", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YOLA II",              "polling unit code": "023", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "ZAGE DANTSE I",        "polling unit code": "024", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "ZAGE ISLAMIYYA (ZAGE DANTSE II)", "polling unit code": "025", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "BADUME PSIII",          "polling unit code": "026", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "BADUME PS IV",          "polling unit code": "027", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "GJSS BADUME I",        "polling unit code": "028", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "GJSS BADUME II",       "polling unit code": "029", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SANAKUR II",           "polling unit code": "030", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "TSAURE III",           "polling unit code": "031", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "TSAURE IV",            "polling unit code": "032", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YAKASAI II",           "polling unit code": "033", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YANBUNDU II",          "polling unit code": "034", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YOLA III",             "polling unit code": "035", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YOLA IV",              "polling unit code": "036", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "YANLEMAN II",          "polling unit code": "037", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SABO KANAWA III",      "polling unit code": "038", "coordinates": [12.2225, 8.3063]},
  {"ward name": "BADUME WARD", "polling unit name": "SABO KANAWA IV",       "polling unit code": "039", "coordinates": [12.2225, 8.3063]},

  {"ward name": "BICHI WARD",  "polling unit name": "CHIRANCHI PRI. SCH. (BUDEN GARI I)",  "polling unit code": "001", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KUR’ANIC MODEL PRI. SCH. (BUDEN GARI II)", "polling unit code": "002", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "BUDEN WAJE",                 "polling unit code": "003", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "DANGAWO ISLAMIYA (DANGAWO)",    "polling unit code": "004", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "DANDUSHE",                  "polling unit code": "005", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "DUTSEN KARYA",              "polling unit code": "006", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "FARAS ISLAMIYYA (FARAS)",   "polling unit code": "007", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA I",                "polling unit code": "008", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA II",               "polling unit code": "009", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "AGENCY FORMASS EDU (HAGAGAWA III)", "polling unit code": "010", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA MODEL PRI. (HAGAGAWA IV)", "polling unit code": "011", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA LIBRARY (HAGAGAWA V)", "polling unit code": "012", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HUGALAWA KANAWA I",         "polling unit code": "013", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA KANAWA ISLAMIYA (HUGALAWA KANAWA II)", "polling unit code": "014", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KOMAU",                     "polling unit code": "015", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON GARI I",             "polling unit code": "016", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ISLAMIYA NEPA (SABON GARI II)", "polling unit code": "017", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "TOWN HALL (SABON GARI III)", "polling unit code": "018", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABARU YANGISHIRI",         "polling unit code": "019", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "G.G.A.J.S.S (SABO LAYI (TKY))", "polling unit code": "020", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KANTI PRI. SCH. (SABON LAYIYAMMA I)", "polling unit code": "021", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "S/LAYI KANTI NEW PRI. SCH. I (SABON LAYIYAMMA II)", "polling unit code": "022", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "S/LAYI KANTI OLD PRI. SCH. II (SABON LAYI KANTI I)", "polling unit code": "023", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "G.G.A.J.S.S (SABON LAYI KANTI II)", "polling unit code": "024", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KANTIN NEW PRI. SCH. I (SABON LAYI (TKY))", "polling unit code": "025", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KANTIN NEW PRI. SCH. II (SABON LAYI C/GARI)", "polling unit code": "026", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "TABANNI",                   "polling unit code": "027", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ISLAMIYA FILIN YARKASUWA I (ZANGO I)", "polling unit code": "028", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ISLAMIYA FILIN YARKASUWA II (ZANGO II)", "polling unit code": "029", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "G.D.J.S.S. ZANGO I (ZANGO III)", "polling unit code": "030", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "G.D.J.S.S. ZANGO II (ZANGO IV)", "polling unit code": "031", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ZANGO KARARI PRI. SCH. (ZANGO V)", "polling unit code": "032", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON LAYI KANTI I",        "polling unit code": "033", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON LAYI KANTI II",       "polling unit code": "034", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON LAYI KANTI OLD PS III", "polling unit code": "035", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON LAYI KANTI OLD PRI SCH IV", "polling unit code": "036", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON LAYI OLD PRI. SCH V",  "polling unit code": "037", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KANTI NEW PRI. SCH. II",    "polling unit code": "038", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GGSS BICHII GWARZO ROAD",   "polling unit code": "040", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GGSS BICHI",                "polling unit code": "041", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SANTAR NAMAMA ISLAMIYYA", "polling unit code": "042", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GDJSS ZANGO II (ZANGO III)", "polling unit code": "043", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GDJSS ZANGO III",           "polling unit code": "044", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GDJSS ZANGO IV",            "polling unit code": "045", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ZANGO ISLAMIYA II",         "polling unit code": "046", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HUGALAWA KANAWA III",       "polling unit code": "047", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HUGALAWA KANAWA IV",        "polling unit code": "048", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ISLAMIYYA KANAWA",         "polling unit code": "049", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GSS BUDEN GARI I",          "polling unit code": "050", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GSS BUDEN GARI II",         "polling unit code": "051", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GGSS BUDEN GARI",          "polling unit code": "052", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GGSS BUDEN GARI II",       "polling unit code": "053", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "TOWN HALL (SG IV)",        "polling unit code": "054", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA MODEL PS II",       "polling unit code": "055", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA MODEL PS III",      "polling unit code": "056", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA II",               "polling unit code": "057", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA III",              "polling unit code": "058", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA IV",               "polling unit code": "059", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "AGENCY FOR MASS EDU II",     "polling unit code": "060", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA LIBRARY I",        "polling unit code": "061", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "HAGAGAWA LIBRARY II",       "polling unit code": "062", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "SABON GARI II",             "polling unit code": "063", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ISLAMIYA NEPA II",         "polling unit code": "064", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "BUDEN WAJE II",             "polling unit code": "065", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "BUDEN WAJE III",            "polling unit code": "066", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KARARI PRI. SCH.",          "polling unit code": "067", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "KOMAU II",                  "polling unit code": "068", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "ZANGO KARARI PRI. SCH.",    "polling unit code": "069", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "FARAS ISLAMIYA II",         "polling unit code": "070", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "DANGAWO KANAWA II",         "polling unit code": "071", "coordinates": [12.2334, 8.2403]},
  {"ward name": "BICHI WARD",  "polling unit name": "GGAJSS II",                 "polling unit code": "072", "coordinates": [12.2334, 8.2403]},

  {"ward name": "DANZABUWA WARD", "polling unit name": "DANZABUWA I",            "polling unit code": "001", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DANZABUWA II",           "polling unit code": "002", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DINSIRI PRI. SCH. I (DANYA/MAHUTA I)", "polling unit code": "003", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DINSIRI PRI. SCH. II (DANYA/MAHUTA II)", "polling unit code": "004", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DISHI/YALWA I",         "polling unit code": "005", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "G.J.S.S MALIKAWA GARU (DISHI/YALWA II)", "polling unit code": "006", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "ISLAMIYYA (JAMAAR MASHI)",   "polling unit code": "007", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "MALIKAWA GARU I",        "polling unit code": "008", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "MALIKAWA ISLAMIYA (MALIKAWA GURU II)", "polling unit code": "009", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "MALIKAWA SARARI I",      "polling unit code": "010", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "MALIKAWA SARARI II",     "polling unit code": "011", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "NASARAWA",              "polling unit code": "012", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "D/ZABUWA PRY SCHOOL I (RD FANNAU I)", "polling unit code": "013", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "D/ZABUWA PRY SCHOOL II (RD FANNAU II)", "polling unit code": "014", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "SHAMI KAWA",             "polling unit code": "015", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "ZAGIN GARI I",           "polling unit code": "016", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "ZAGIN GARI II",          "polling unit code": "017", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "MALIKAWA ISLAMIYYA III", "polling unit code": "018", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "MALIKAWA ISLAMIYYA II",  "polling unit code": "019", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "KYALLIN BULA",           "polling unit code": "020", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DANZABUWA ISLAMIYYA",   "polling unit code": "021", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DANZABUWA ISLAMIYYA II", "polling unit code": "022", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DANZABUWA PS II (RD FANAU II)", "polling unit code": "024", "coordinates": [12.3641, 8.1342]},
  {"ward name": "DANZABUWA WARD", "polling unit name": "DANZABUWA PS IV",        "polling unit code": "025", "coordinates": [12.3641, 8.1342]},

  {"ward name": "FAGOLO WARD", "polling unit name": "FAGOLO C/GARI I",          "polling unit code": "001", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "WALAWE (FAGOLO C/GARI II)", "polling unit code": "002", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "FATAU NEW PRI. SCHOOL (FATAU)", "polling unit code": "003", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "HUNGADE NEW ISLAMIYYA (HUNGADE I)", "polling unit code": "004", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "HUNGADE II",               "polling unit code": "005", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "J/KADARE I",               "polling unit code": "006", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "J/KADARE II",              "polling unit code": "007", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "J/TANGAJI",               "polling unit code": "008", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "KUNGU I",                  "polling unit code": "009", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "KUNGU II",                 "polling unit code": "010", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "TUKUIBI I",               "polling unit code": "011", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "TUKUIBI II",              "polling unit code": "012", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "YATSI",                   "polling unit code": "013", "coordinates": [12.2712, 8.4324]},
  {"ward name": "FAGOLO WARD", "polling unit name": "FAGOLO CIKIN GARI II",      "polling unit code": "014", "coordinates": [12.2712, 8.4324]},

  {"ward name": "KAUKAU WARD", "polling unit name": "DAMISA",                   "polling unit code": "001", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "GADU ISLAMIYYA (GADU)",     "polling unit code": "002", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "GIRAWA ISLAMIYA (GIRAWA)",   "polling unit code": "003", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "HUGGALAWA I",              "polling unit code": "004", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "HUGGALAWA II",             "polling unit code": "005", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "KAU-KAU RIMAYE",          "polling unit code": "006", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "ISLAMIYYA KAU-KAU (KAU-KAU C/GARI I)", "polling unit code": "007", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "KAU-KAU C/GARI II",         "polling unit code": "008", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "KADANDANI ISLAMIYYA I (KADANDANI I)", "polling unit code": "009", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "KADANDANI ISLAMIYYA II (KADANDANI II)", "polling unit code": "010", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "ISLAMIYYA (LUGGE FULANI I)",   "polling unit code": "011", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "ISLAMIYYA LUGGE (LUGGE FULANI II)", "polling unit code": "012", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "YANDUTSE",                 "polling unit code": "013", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "KAU KAU RIMAYE II",       "polling unit code": "014", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "KAU KAU RIMAYE II",       "polling unit code": "015", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "GIRAWA ISLAMIYA II",       "polling unit code": "016", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "YANDUTSE II",             "polling unit code": "017", "coordinates": [12.2671, 8.2262]},
  {"ward name": "KAUKAU WARD", "polling unit name": "LUGGE FULANI II",          "polling unit code": "018", "coordinates": [12.2671, 8.2262]},

  {"ward name": "KWAMARAWA WARD", "polling unit name": "CHIROMAWA",             "polling unit code": "001", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "GALADIMAWA",            "polling unit code": "002", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "GALAJE",                "polling unit code": "003", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "J/MANCE",               "polling unit code": "004", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KOFAR GIDAN M/UNGUWA (KOZAU)", "polling unit code": "005", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KWAMARAWA",             "polling unit code": "006", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KWANDAWA FULANI I",      "polling unit code": "007", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KWANDAWA FULANI II",     "polling unit code": "008", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KWANDAWA FULANI III",    "polling unit code": "009", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "MARGA",                 "polling unit code": "010", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KOFAR G/MAI UNGUWA DISPENSARY I (MARGA DARI I)", "polling unit code": "011", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KOFAR G/MAI UNGUWA DISPENSARY II (MARGA DARI II)", "polling unit code": "012", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "MARKE",                 "polling unit code": "013", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "MAGINZAWA",             "polling unit code": "014", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "TINKI I",               "polling unit code": "015", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "TINKI II",              "polling unit code": "016", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "TINKI II",              "polling unit code": "017", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "KWAMARAWA II",          "polling unit code": "018", "coordinates": [12.3023, 8.3795]},
  {"ward name": "KWAMARAWA WARD", "polling unit name": "MARGA II",              "polling unit code": "019", "coordinates": [12.3023, 8.3795]},

  {"ward name": "KYALLI WARD", "polling unit name": "BARE, BARI",             "polling unit code": "001", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "CHIROMAWA I",           "polling unit code": "002", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "CHIROMAWA II",          "polling unit code": "003", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "CHIROMAWA III",         "polling unit code": "004", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "HAGAWA",               "polling unit code": "005", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "JIGAWA",               "polling unit code": "006", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "JAMAAR GARA",          "polling unit code": "007", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "KYALLI C/GARI I",       "polling unit code": "008", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "KYALLI C/GARI II",      "polling unit code": "009", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "KOZAWA",               "polling unit code": "010", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "DISPENSARY MAKWARO (MAKWARO)", "polling unit code": "011", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "RUDDU ISLAMIYA (RUDDU)", "polling unit code": "012", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "SAYA SAYA PRI. SCH. (SAYA-SAYA)", "polling unit code": "013", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "TSIDAU DISPENSARY (TSIDAU)", "polling unit code": "014", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "UNG. GAJERE UNDER TREE (UNG. GAJERE)", "polling unit code": "015", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "YANGGWARZO",            "polling unit code": "016", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "ZANGON GADU",          "polling unit code": "017", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "CHIROMAWA IV",          "polling unit code": "018", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "KYALLI CIKIN GARI III",  "polling unit code": "019", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "KYALLI CIKIN GARI IV",   "polling unit code": "020", "coordinates": [12.2667, 8.1594]},
  {"ward name": "KYALLI WARD", "polling unit name": "KYALLI CIKIN GARI V",    "polling unit code": "021", "coordinates": [12.2667, 8.1594]},

  {"ward name": "MUNTSIRA WARD", "polling unit name": "ISLAMIYYA CENTRE (A’AWA I)",   "polling unit code": "001", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "NEW PRIMARY SCHOOL (A’AWA II)",  "polling unit code": "002", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "IYAWA PRI. SCHOOL (IYAWA)",     "polling unit code": "003", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "KARGON BICHI SEC. SCH I (KARGON BICHI I)", "polling unit code": "004", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "KARGON BICHI SEC. SCH II (KARGON BICHI II)", "polling unit code": "005", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "MADINAI PRI. SCH. (KARGON BICHI III)", "polling unit code": "006", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "MUNTSIRA I",              "polling unit code": "007", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "MUNTSIRA ILAMIYYA (MUNTSIRA II)", "polling unit code": "008", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "SABARU PRIMARY SCHOOL (SABARU MUNTSIRA)", "polling unit code": "009", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "SADI IYAWA",             "polling unit code": "010", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "TSARAKA AAWA I",         "polling unit code": "011", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "TSARAKA AAWA II",        "polling unit code": "012", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "TSARAKA A’AWA CLINIC (TSARAKA AAWA III)", "polling unit code": "013", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "KARGON BICHII SEC. SCH NEW", "polling unit code": "014", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "MADINAI PRI. SCH. II (KARGON BICHII)", "polling unit code": "015", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "MUNTSIRA II",             "polling unit code": "016", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "MUNTSIRA ISLAMIYYA II",   "polling unit code": "017", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "IYAWA II",               "polling unit code": "018", "coordinates": [12.1892, 8.2228]},
  {"ward name": "MUNTSIRA WARD", "polling unit name": "SABARU MUNTSIRA II",     "polling unit code": "019", "coordinates": [12.1892, 8.2228]},

  {"ward name": "SAYE WARD", "polling unit name": "BUNBUR ABUKUR I",         "polling unit code": "001", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "BUNBUR ABUKUR II",        "polling unit code": "002", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "GARUN BATURE PRI. SCH. B I (DISHI I)", "polling unit code": "003", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "GARUN BATURE PRI. SCH. B II (DISHI II)", "polling unit code": "004", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "GARUN BATURE I",          "polling unit code": "005", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "GARUN BATURE II",         "polling unit code": "006", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "SAYE I",                 "polling unit code": "007", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "SAYE II",                "polling unit code": "008", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "UNG. GABAS I",           "polling unit code": "009", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "UNG. GABAS II",          "polling unit code": "010", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "YAMMA MAKERA TRANSFORMER (YAMMA MAKERA I)", "polling unit code": "011", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "YAMMA MAKERA GIDAN RUWA (YAMMA MAKERA II)", "polling unit code": "012", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "ISLAMIYYA PRI. SCHOOL (YAMMA MAKERA III)", "polling unit code": "013", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "SAYE III",               "polling unit code": "014", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "SAYE IV",                "polling unit code": "015", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "YAMMA MAKERA II",         "polling unit code": "016", "coordinates": [12.2805, 8.3981]},
  {"ward name": "SAYE WARD", "polling unit name": "UNGUWAR GABAS II",       "polling unit code": "017", "coordinates": [12.2805, 8.3981]},

  {"ward name": "WAIRE WARD", "polling unit name": "OPPOSITE MASALLACHI (BANDUTSE)", "polling unit code": "001", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "BELLI I",                "polling unit code": "002", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "BELLI B PRIMARY SCHOOL (BELLI II)", "polling unit code": "003", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "DUTSEN DORAWA I",        "polling unit code": "004", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "DUTSEN DORAWA II",       "polling unit code": "005", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "JINJIMAWA I",           "polling unit code": "006", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "JINJIMAWA II",          "polling unit code": "007", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "MALLADE",               "polling unit code": "008", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "RUNTIMI UNDER TREE (RUNTUMI)", "polling unit code": "009", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "WAIRE PRI. SCHOOL I (WAIRE, C/GARI I)", "polling unit code": "010", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "WAIRE PRI. SCHOOL II (WAIRE, C/GARI II)", "polling unit code": "011", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "ZANGO KADARE ISLAMIYYA I (ZANGON KADARE I)", "polling unit code": "012", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "ZANGO KADERE ISLAMIYYA II (ZANGON KADARE II)", "polling unit code": "013", "coordinates": [12.3125, 8.2495]},
  {"ward name": "WAIRE WARD", "polling unit name": "BELLI II",               "polling unit code": "014", "coordinates": [12.3125, 8.2495]},

  {"ward name": "YALLAMI WARD", "polling unit name": "DADDO PRI. SCHOOL (BEGUWA)", "polling unit code": "001", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "DADDO",                 "polling unit code": "002", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "DAMARGU I",             "polling unit code": "003", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "DAMARGU II",            "polling unit code": "004", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "DUNAWA",                "polling unit code": "005", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "KANTAKARA",             "polling unit code": "006", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "YAN SHAYI (SANTAR RAGO I)", "polling unit code": "007", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "SANTAR RAGO II",         "polling unit code": "008", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "TUDUN WADA MARKET SPADE (T/WADA)", "polling unit code": "009", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "TSAURI I",               "polling unit code": "010", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "TSAURI II",              "polling unit code": "011", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "UNG. KOFA",             "polling unit code": "012", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "YALLAMI I",             "polling unit code": "013", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "YALLAMI II",            "polling unit code": "014", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "YANLAMI MARKET SHADE (YALLAMI III)", "polling unit code": "015", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "YARTASHA ISLAMIYYA (YARTASHA)", "polling unit code": "016", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "KANTAKARA III",          "polling unit code": "017", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "YALLAMI IV",            "polling unit code": "018", "coordinates": [12.3153, 8.3568]},
  {"ward name": "YALLAMI WARD", "polling unit name": "KANTAKARA II",          "polling unit code": "019", "coordinates": [12.3153, 8.3568]}
]
// --- end pollingUnits array ---

// ===== Translations (English + Hausa) =====
const translations = {
  en: {
    heroTitle: "Polling Units Directory",
    heroDescription:
      "Find your polling unit easily and get directions to exercise your democratic right. All polling units in Bichi Federal Constituency are listed below.",
    locationFinderTitle: "Find Your Nearest Polling Unit",
    locationFinderDescription: "Enter your address or allow location access to find the polling unit closest to you.",
    addressPlaceholder: "Enter your address or location",
    findUnitButton: "Find Nearest Unit",
    getCurrentLocation: "Use Current Location",
    nearestUnitTitle: "Your Nearest Polling Unit",
    allUnitsTitle: "All Polling Units by Ward",
    searchPlaceholder: "Search for a polling unit or ward...",
    distance: "Distance",
    getDirections: "Get directions",
  },
  ha: {
    heroTitle: "Littafin Wuraren Zabe",
    heroDescription:
      "Nemo wurin zabenka cikin sauki kuma ka sami hanyar zuwa don amfani da haƙƙin dimokuradiyyarka. Duk wuraren zabe a Mazabar Bichi an jera su a ƙasa.",
    locationFinderTitle: "Nemo Wurin Zaben da ya fi Kusa da Kai",
    locationFinderDescription:
      "Shigar da adireshinki ko bari a sami wurin da kake don nemo wurin zaben da ya fi kusa da kai.",
    addressPlaceholder: "Shigar da adireshinki ko wurin da kake",
    findUnitButton: "Nemo Wurin da ya fi Kusa",
    getCurrentLocation: "Yi Amfani da Wurin da nake Yanzu",
    nearestUnitTitle: "Wurin Zaben da ya fi Kusa da Kai",
    allUnitsTitle: "Duk Wuraren Zabe bisa ga Ward",
    searchPlaceholder: "Nemo wurin zabe ko ward...",
    distance: "Nisa",
    getDirections: "Samu hanyoyi",
  },
}

// ===== Helpers =====
function haversineDistance(coords1, coords2) {
  // coords are [lat, lng]
  const toRad = (x) => (x * Math.PI) / 180
  const R = 6371 // km
  const dLat = toRad(coords2[0] - coords1[0])
  const dLon = toRad(coords2[1] - coords1[1])
  const lat1 = toRad(coords1[0])
  const lat2 = toRad(coords2[0])

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

// Component to control map from outside (flyTo)
function MapController({ target }) {
  const map = useMap()
  useEffect(() => {
    if (target && target.coordinates) {
      map.flyTo(target.coordinates, 15)
    }
  }, [target, map])
  return null
}

// ===== Main component =====
export default function PollingUnits({ language = "en" }) {
  const t = translations[language] || translations.en

  const [isVisible, setIsVisible] = useState(false)
  const [userAddress, setUserAddress] = useState("")
  const [nearestUnit, setNearestUnit] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [selectedUnit, setSelectedUnit] = useState(null)
  const mapRef = useRef(null)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  // build ward list from pollingUnits
  const wards = useMemo(() => {
    const byWard = {}
    pollingUnits.forEach((pu) => {
      const ward = pu["ward name"] || "Unknown Ward"
      if (!byWard[ward]) byWard[ward] = []
      byWard[ward].push(pu)
    })
    // Convert to sorted array of { name, units }
    return Object.keys(byWard)
      .sort()
      .map((wardName) => ({
        name: wardName,
        units: byWard[wardName],
      }))
  }, [])

  // Filtered wards based on search
  const filteredWards = useMemo(() => {
    const s = searchTerm.trim().toLowerCase()
    if (!s) return wards
    return wards
      .map((w) => ({
        ...w,
        units: w.units.filter(
          (u) =>
            (u["polling unit name"] || "").toLowerCase().includes(s) ||
            (u["polling unit code"] || "").toLowerCase().includes(s),
        ),
      }))
      .filter((w) => w.units.length > 0 || w.name.toLowerCase().includes(s))
  }, [searchTerm, wards])

  // Find nearest by user-provided address (we simulate by geoloc or simply use geolocation only)
  const findNearestUnit = async (coords) => {
    // coords: [lat, lng] - if undefined, try geolocation
    let userCoords = coords
    if (!userCoords) {
      if (!navigator.geolocation) {
        alert("Geolocation is not supported by your browser.")
        return
      }
      setIsLoading(true)
      try {
        const pos = await new Promise((resolve, reject) =>
          navigator.geolocation.getCurrentPosition(resolve, reject),
        )
        userCoords = [pos.coords.latitude, pos.coords.longitude]
      } catch (err) {
        setIsLoading(false)
        alert("Unable to get your location. Please enter your address or try again.")
        return
      } finally {
        setIsLoading(false)
      }
    }

    let nearest = null
    let minDist = Infinity
    pollingUnits.forEach((pu) => {
      if (!pu.coordinates || pu.coordinates.length !== 2) return
      const dist = haversineDistance(userCoords, pu.coordinates)
      if (dist < minDist) {
        minDist = dist
        nearest = { ...pu, distanceKm: dist }
      }
    })

    if (nearest) {
      setNearestUnit(nearest)
      setSelectedUnit(nearest)
      // pan map to nearest
      if (mapRef.current) {
        mapRef.current.setView(nearest.coordinates, 15)
      }
    } else {
      alert("No polling units found.")
    }
  }

  const handleUseCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported")
      return
    }
    setIsLoading(true)
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setIsLoading(false)
        const coords = [position.coords.latitude, position.coords.longitude]
        setUserAddress("Current Location")
        findNearestUnit(coords)
      },
      (err) => {
        setIsLoading(false)
        alert("Unable to get location: " + (err.message || "permission denied"))
      },
    )
  }

  // helper to open google maps directions (origin = user coords if available)
  const getGoogleMapsDirectionsUrl = (destinationCoords, originCoords) => {
    const dest = `${destinationCoords[0]},${destinationCoords[1]}`
    if (originCoords && originCoords.length === 2) {
      const origin = `${originCoords[0]},${originCoords[1]}`
      return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(
        origin,
      )}&destination=${encodeURIComponent(dest)}&travelmode=driving`
    }
    // if origin unknown, just open destination
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(dest)}`
  }

  // we keep a local origin coords if user used geolocation
  const [originCoords, setOriginCoords] = useState(null)
  const handleGetCurrentLocationForDirections = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported")
      return
    }
    setIsLoading(true)
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setIsLoading(false)
        const coords = [position.coords.latitude, position.coords.longitude]
        setOriginCoords(coords)
        alert("Current location captured — now click Get directions on a polling unit.")
      },
      (err) => {
        setIsLoading(false)
        alert("Unable to get location for directions: " + (err.message || "permission denied"))
      },
    )
  }

  // The default center is Bichi town approximate
  const defaultCenter = [12.2334, 8.2403]

  return (
    <div className="polling-units">
      {/* Hero */}
      <section className="polling-hero">
        <div className={`polling-hero-content ${isVisible ? "fade-in" : ""}`}>
          <h1>{t.heroTitle}</h1>
          <p>{t.heroDescription}</p>
        </div>
      </section>

      {/* Content */}
      <div className="polling-content">
        {/* Location Finder */}
        <section className={`location-finder ${isVisible ? "slide-in-up" : ""}`}>
          <h2>{t.locationFinderTitle}</h2>
          <p>{t.locationFinderDescription}</p>

          <div className="location-form">
            <input
              type="text"
              className="location-input"
              placeholder={t.addressPlaceholder}
              value={userAddress}
              onChange={(e) => setUserAddress(e.target.value)}
            />
            <button
              className="location-btn"
              onClick={() => {
                // If user typed an address we don't have geocoding here (no external API).
                // So we will attempt geolocation; otherwise ask them to use current location.
                if (!userAddress || userAddress === "Current Location") {
                  handleUseCurrentLocation()
                } else {
                  // We can't geocode without an API — prompt user to use current location
                  alert(
                    "Please use 'Use Current Location' for an accurate result, or paste coordinates into the address field in format: lat,lng",
                  )
                  // If user provided "lat,lng" we can parse:
                  const coords = userAddress.split(",").map((s) => parseFloat(s.trim()))
                  if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
                    findNearestUnit(coords)
                    setOriginCoords(coords)
                  }
                }
              }}
              disabled={isLoading}
            >
              {isLoading ? "..." : t.findUnitButton}
            </button>

            <button
              className="location-btn"
              onClick={() => {
                handleUseCurrentLocation()
              }}
              disabled={isLoading}
            >
              {isLoading ? "..." : t.getCurrentLocation}
            </button>

            <button
              className="location-btn"
              onClick={() => handleGetCurrentLocationForDirections()}
              title="Capture your current location to use as origin for Google Maps directions"
            >
              Capture Location for Directions
            </button>
          </div>

          {nearestUnit && (
            <div className="nearest-unit" style={{ marginTop: "1rem" }}>
              <h3>{t.nearestUnitTitle}</h3>
              <p>
                <strong>{nearestUnit["polling unit name"]}</strong>
              </p>
              <p>Code: {nearestUnit["polling unit code"]}</p>
              <p>Ward: {nearestUnit["ward name"]}</p>
              <div className="distance">
                {t.distance}: {nearestUnit.distanceKm ? `${nearestUnit.distanceKm.toFixed(2)} km` : "—"}
              </div>
              <div style={{ marginTop: "0.5rem" }}>
                <a
                  href={getGoogleMapsDirectionsUrl(nearestUnit.coordinates, originCoords)}
                  target="_blank"
                  rel="noreferrer"
                  className="location-btn"
                  style={{ marginTop: "0.5rem" }}
                >
                  {t.getDirections}
                </a>
              </div>
            </div>
          )}
        </section>

        {/* Search input */}
        <section className={`search-section ${isVisible ? "slide-in-up" : ""}`} style={{ marginTop: "1.5rem" }}>
          <input
            type="text"
            className="search-input"
            placeholder={t.searchPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </section>

        {/* Map and List layout */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 420px", gap: "1.5rem", marginTop: "2rem" }}>
          {/* Map */}
          <div style={{ minHeight: "500px", borderRadius: 12, overflow: "hidden" }}>
            <MapContainer
              center={defaultCenter}
              zoom={11}
              style={{ height: "100%", width: "100%" }}
              whenCreated={(mapInstance) => {
                mapRef.current = mapInstance
              }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="" />
              {pollingUnits.map((pu, idx) => {
                // show marker
                return (
                  <Marker key={idx} position={pu.coordinates}>
                    <Popup>
                      <div style={{ minWidth: 180 }}>
                        <strong>{pu["polling unit name"]}</strong>
                        <br />
                        Code: {pu["polling unit code"]}
                        <br />
                        Ward: {pu["ward name"]}
                        <br />
                        <div style={{ marginTop: 6 }}>
                          <a
                            href={getGoogleMapsDirectionsUrl(pu.coordinates, originCoords)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t.getDirections}
                          </a>
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                )
              })}
              {/* When a unit is selected we fly to it */}
              {selectedUnit && <MapController target={selectedUnit} />}
            </MapContainer>
          </div>

          {/* Right-hand list */}
          <aside style={{ maxHeight: 600, overflowY: "auto", paddingRight: 8 }}>
            <h3 style={{ marginTop: 0, color: "#1a5f3f" }}>{t.allUnitsTitle}</h3>

            {filteredWards.map((ward, wIdx) => (
              <div key={wIdx} className="ward-card" style={{ marginBottom: 12 }}>
                <div className="ward-header">
                  <h4 className="ward-name" style={{ margin: 0, fontSize: 16 }}>
                    {ward.name}
                  </h4>
                  <span className="ward-code">PUs: {ward.units.length}</span>
                </div>

                <ul className="polling-units-list" style={{ marginTop: 10 }}>
  {ward.units.map((unit, uIdx) => (
    <li
      key={uIdx}
      className="polling-unit-item"
      style={{ cursor: "pointer" }}
      onClick={() => {
        setSelectedUnit(unit)
        setNearestUnit(null)
        if (mapRef.current && unit.coordinates) {
          // Always fly to this unit
          mapRef.current.flyTo(unit.coordinates, 15)

          // Open popup for this marker if exists
          const leafletLayer = mapRef.current._layers
          Object.values(leafletLayer).forEach((layer) => {
            if (layer.getLatLng && layer.getLatLng().lat === unit.coordinates[0] && layer.getLatLng().lng === unit.coordinates[1]) {
              if (layer.openPopup) {
                layer.openPopup()
              }
            }
          })
        }
      }}
    >
      <span className="unit-name">{unit["polling unit name"]}</span>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <a
          className="unit-code"
          style={{ textDecoration: "none", padding: "6px 8px", display: "inline-block" }}
          onClick={(e) => {
            e.stopPropagation()
            const url = getGoogleMapsDirectionsUrl(unit.coordinates, originCoords)
            window.open(url, "_blank", "noopener")
          }}
        >
          {t.getDirections}
        </a>
        <span className="unit-code">{unit["polling unit code"]}</span>
      </div>
    </li>
  ))}
</ul>

              </div>
            ))}

            {/* If nothing found */}
            {filteredWards.length === 0 && (
              <div style={{ padding: 12, color: "#6c757d" }}>
                <p>No wards or polling units match your search.</p>
              </div>
            )}
          </aside>
        </div>

        {/* Optional summary area */}
        <div style={{ marginTop: 24 }}>
          <p style={{ color: "#666" }}>
            Tip: Click any polling unit row to zoom to it on the map. Use "Use Current Location" to find the nearest
            polling unit. Capture your current location to use as origin for Get Directions links.
          </p>
        </div>
      </div>
    </div>
  )
}
